/**
 * Build MUI theme from CatalogueSettings (primary/secondary from Settings tab).
 */

import { createTheme } from '@mui/material/styles';
import type { CatalogueSettings } from '../types';
import { DEFAULT_CATALOGUE_SETTINGS } from '../types';

export function createThemeFromSettings(settings: CatalogueSettings) {
  const C = settings.colours;
  return createTheme({
    palette: {
      primary: {
        main: C.primary_purple,
        dark: C.primary_dark,
        light: C.primary_pink,
      },
      secondary: {
        main: C.primary_dark,
      },
      background: {
        default: C.supplementary_light_grey,
        paper: '#ffffff',
      },
      text: {
        primary: C.primary_dark,
      },
    },
    typography: {
      fontFamily: "'Segoe UI', Calibri, Arial, sans-serif",
      h6: { fontWeight: 600 },
      subtitle2: { fontWeight: 600 },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: 'none', borderRadius: 6 },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 4 },
        },
      },
    },
  });
}

export const defaultTheme = createThemeFromSettings(DEFAULT_CATALOGUE_SETTINGS);
